// Centralized API config — Vite build reads VITE_API_BASE.
// AuthContext.tsx uses the same pattern; keep in sync so cross-origin
// (id.cloudgenie.co → app.cloudgenie.co) calls actually hit the backend.
// Fallback to the production backend host — same rationale as AuthContext.
export const API_BASE = import.meta.env.VITE_API_BASE || 'https://app.cloudgenie.co';
export const API = `${API_BASE}/api`;
